import ComponentHeader from '../main/ComponentHeader';
import GruntComponents from '../components';
import {Box, InputGroup, InputLeftElement, Input, Spacer, Stack, Menu,MenuButton, Button,Tooltip,
   MenuList, MenuItem, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, useToast,IconButton,
   ModalContent,ModalHeader,ModalFooter,Modal, ModalBody,ModalCloseButton, SkeletonCircle,SkeletonText
   } from '@chakra-ui/react';
import { SearchIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { userCanEdit,userReadOnly } from '../../util/grunt';
import { useState, useEffect, useCallback } from 'react';
import {MdFilterAltOff, MdFilterAlt,MdInfo} from 'react-icons/md';
import {RiFileExcel2Fill} from "react-icons/ri"
import Odlazak from './Odlazak';
import OdlasciTable from './OdlasciTable';
import { addOdlazak,getOdlasci,deleteOdlazak,editOdlazak,getOdlasciFilter} from '../../util/apiMigracija';
import Dolazak from '../dolazak/Dolazak';
import OdlasciFilter from './OdlasciFIlter';
import OdlazakFilterInfo from './OdlazakFilterInfo';

export default function Odlasci({onClosePress,size='xs'}) {

  const [state,setState]=useState({newOdlazak:"",editOdlazakMigracijaId:0,editMigracijaTipSifra:"",viewOdlazakMigracijaId:0,viewMigracijaTipSifra:"",viewDolazakMigracijaId:0,toggleShowData:false})
  const [odlasci,setOdlasci]=useState([]);
  const [canSave,setCanSave]=useState(true);
  const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",odlasciprikaz:[],rowsperpage:20,currpage:1});
  const [filter,setFilter]=useState({filterStatus:"off",showFilter:false,filterData:{},ispisType:'app'})
  const [dataIsFetching,setDataIsFetching]=useState(false);
  const [showFilters,setShowFilters]=useState(false);
  const toast=useToast();
  //const userCanEdit=lp.uloga==="r"?false:true;
  //
  /*const fetchOdlasci=async ()=>{
    let res;
    try {
      setDataIsFetching(true);
      if (Object.keys(filter.filterData).length===0) {
        res=await getOdlasci({_verificiran:true,responsedatatype:filter.ispisType});
      } else {
        let xx=filter.filterData;
        xx.responsedatatype=filter.ispisType;
        res=await getOdlasciFilter(xx);
      }

      if (res.status===200) {
        if (filter.ispisType==='app') {
          setOdlasci(res.res);
          setPrikaz({...prikaz,odlasciprikaz:res.res}); 
        } else if (filter.ispisType==='xlsx') {
          const blob = new Blob([res.res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                      
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = "Odlasci.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        }
      } else {
        throw new Error(res.message);
      }
          
    } catch (error) {
        toast({
            title:"Greška kod dohvata podataka.",
            status:"error",
            description:error.message,
            isClosable:true,
            duration:2000,
            position:"top-right",
        });
    } finally {
      setDataIsFetching(false);
      if (filter.ispisType!=='app') {
        setFilter({...filter,ispisType:'app'});
      }
    }
}

useEffect(() => {
  fetchOdlasci();
}, [filter.filterData,state.toggleShowData])
*/

const fetchOdlasci = useCallback(async () => {
    let res;
    try {
      setDataIsFetching(true);
      if (Object.keys(filter.filterData).length===0) {
        res=await getOdlasci({_verificiran:true,responsedatatype:filter.ispisType});
      } else {
        let xx=filter.filterData;
        xx.responsedatatype=filter.ispisType;
        res=await getOdlasciFilter(xx);
      }

      if (res.status===200) {
        if (filter.ispisType==='app') {
          setOdlasci(res.res);
          setPrikaz(p => ({...p, odlasciprikaz: res.res})) 
        } else if (filter.ispisType==='xlsx') {
          const blob = new Blob([res.res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                      
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = "Odlasci.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        }
      } else {
        throw new Error(res.message);
      }
          
    } catch (error) {
        toast({
            title:"Greška kod dohvata podataka.",
            status:"error",
            description:error.message,
            isClosable:true,
            duration:2000,
            position:"top-right",
        });
    } finally {
      setDataIsFetching(false);
      if (filter.ispisType!=='app') {
        setFilter(f => f.ispisType !== 'app' ? {...f, ispisType: 'app'} : f);
      }
    }
}, [filter.filterData, filter.ispisType, toast]) // ← dependenciji koje fetchOdlasci koristi

useEffect(() => {
  fetchOdlasci();
}, [fetchOdlasci]) // ← sada samo fetchOdlasci

  //
  const btnNew=()=>{
    if (userCanEdit()) {
        return (
           <Menu size={'sm'}>
                <MenuButton as={Button} rightIcon={<ChevronDownIcon />} variant={'outline'} colorScheme={'grunt2'} size={size}>
                    Odlazak
                </MenuButton>
                <MenuList fontSize={size}>
                    <MenuItem onClick={(e)=>setState({...state,newOdlazak:"OPROD"})}>Prodaja</MenuItem>
                    <MenuItem onClick={(e)=>setState({...state,newOdlazak:"OIZVZ"})}>Izvoz</MenuItem>
                    <MenuItem onClick={(e)=>setState({...state,newOdlazak:"OKLA"})}>Klaonica</MenuItem>
                    <MenuItem onClick={(e)=>setState({...state,newOdlazak:"OMIK"})}>Migracija između knjiga</MenuItem>
                    <MenuItem onClick={(e)=>setState({...state,newOdlazak:"OIZGB"})}>Krađa/Izgubljeno</MenuItem>
                </MenuList>
            </Menu>
            )
    } else {
        return (
            <></>
            )
    }
  }

const deleteSelectedOdlazak=async(odlmigracijaid)=>{
  try {
    const res=await deleteOdlazak({migracijaid:odlmigracijaid});
    if (res.status===200) {
      setState({...state,newOdlazak:"",editOdlazakMigracijaId:0,editMigracijaTipSifra:"",toggleShowData:!state.toggleShowData,viewDolazakMigracijaId:0});  
      toast({
        title:"Odlazak obrisan.",
        status:"success",
        isClosable:true,
        duration:1500,
        position:"top-right",
    });
    } else {
      throw new Error(res.message);
    }
    
  } catch (error) {
    toast({
      title:"Greška kod unosa",
      status:"error",
      description:error.message,
      isClosable:true,
      duration:2000,
      position:"top-right",
  });
  }
    
}


  const saveOdlazak= async (_odldata)=>{
    try {
      setCanSave(false);
      let res;
      let _govedaid=[];
      _odldata.goveda.forEach(gov=>_govedaid.push(gov.govedo_id));
      if (state.editOdlazakMigracijaId===0) {
          //add new
          res=await addOdlazak({dokumenttipid:_odldata.dokument_tip_id,migracijatipsifra:_odldata.migracija_tip_sifra,knjigaid:_odldata.knjiga_id,
            datum:_odldata.datum,migracijaposjednikid:_odldata.migracijaPosjednik.id,migracijaknjigaid:_odldata.migracijaKnjigaId,uktezina:_odldata.uktezina,ijr:_odldata.ijr,
          dokumentbroj:_odldata.dokument_broj,govedaid:_govedaid,jibg:_odldata.jibg});
      } else {
          //edit
           
           res=await editOdlazak({omigracijaid:state.editOdlazakMigracijaId,dokumenttipid:_odldata.dokument_tip_id,knjigaid:_odldata.knjiga_id,
            datum:_odldata.datum,migracijaposjednikid:_odldata.migracijaPosjednik.id,migracijaknjigaid:_odldata.migracijaKnjigaId,uktezina:_odldata.uktezina,ijr:_odldata.ijr,
          dokumentbroj:_odldata.dokument_broj,govedaid:_govedaid,jibg:_odldata.jibg});
  
      } 
        
       //res=await addOdlazak({dokumenttipid,migracijatipsifra,knjigaid,datum,migracijaposjednikid,migracijaknjigaid,uktezina,ijr,dokumentbroj,govedaid:goveda});
      
       
      
      if (res.status===200) {
  
          //setPrikaz({...prikaz,showKlaonica:false,selectedKlaonica:{},fetchklaonice:prikaz.fetchklaonice+1})
          setState({...state,newOdlazak:"",editOdlazakMigracijaId:0,editMigracijaTipSifra:"",toggleShowData:!state.toggleShowData,viewDolazakMigracijaId:0});
          toast({
              title:"Podatak spremljen",
              status:"success",
              isClosable:true,
              duration:1500,
              position:"top-right",
          });
      } else {
         
              throw new Error(res.message);
         
      }
  } catch (ex) {
  toast({
      title:"Greška kod unosa",
      status:"error",
      description:ex.message,
      isClosable:true,
      duration:2000,
      position:"top-right",
  });
  } finally {
    setCanSave(true);
  }
  }

  const getOdlazakControl=()=>{
    let _sif="";
    let _readonly=true;
    let _newodl=false; 
    let _odlmigrid=0;
    if (state.newOdlazak!=="") {
      _sif=state.newOdlazak
      _readonly=false;
      _newodl=true;
    } else if (state.editOdlazakMigracijaId!==0) {
      _sif=state.editMigracijaTipSifra;
      _newodl=false;
      _readonly=!userCanEdit();
      _odlmigrid=state.editOdlazakMigracijaId;
    } else if (state.viewOdlazakMigracijaId!==0) {
      _sif=state.viewMigracijaTipSifra;
      _newodl=false;
      _readonly=true;
      _odlmigrid=state.viewOdlazakMigracijaId;
    }
    if (_sif!=="") {
      let _naslov="Prodaja";
      switch (state.newOdlazak) {
        case "OIZVZ":
          _naslov="Izvoz";
          break;
        case "OKLA":
        _naslov="Klaonica";
          break;
        case "OMIK":
          _naslov="Migracija između knjiga";
          break;
        case "OIZGB":
         _naslov="Krađa/Izgubljeno";
          break;
        default:
          _naslov="Prodaja";
      }
        return (
            <Drawer placement='right' size={'xl'} isOpen={true}>
            <DrawerOverlay/>
            <DrawerContent roundedTopLeft={'md'}>
                <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                    {_naslov}
                </DrawerHeader>
                <DrawerBody>
                        <Odlazak _canSave={canSave} odlazak_tip_sifra={_sif} onClose={closeOdlazakControl} onSave={saveOdlazak} onDelete={deleteSelectedOdlazak} readonly={_readonly} newOdlazak={_newodl} odlazakMigracijaId={_odlmigrid}/>
                </DrawerBody>
            </DrawerContent>
            </Drawer>
        )
    }
}

const closeOdlazakControl=()=>{
  setState({...state,newOdlazak:"",editOdlazakMigracijaId:0,editMigracijaTipSifra:"",viewOdlazakMigracijaId:0,viewMigracijaTipSifra:"",viewDolazakMigracijaId:0});
}

const getOdlasciTable=()=>{
  if (dataIsFetching) {
    return (
      <Box>
        <SkeletonCircle size='10' />
        <SkeletonText mt='4' noOfLines={30} spacing='3' skeletonHeight='2' />
      </Box>
    )
  } else {
    return (
      <Box display={'flex'} flexDir={'column'} flex={1}>
        <OdlasciTable odlasci={prikaz.odlasciprikaz} onEditOdlazak={oneditOdlazak} onViewOdlazak={onviewOdlazak} onViewDolazak={onViewDolazak} readonly={userReadOnly()} />
      </Box>
    )
  }
  
   
}

const oneditOdlazak=(migracijaid,migracijatipsifra)=>{
  setState({...state,newOdlazak:"",editOdlazakMigracijaId:migracijaid,editMigracijaTipSifra:migracijatipsifra,viewDolazakMigracijaId:0});
  //setState({editDolazakMigracijaId:migracijaid,editMigracijaTipSifra:migracijatipsifra});
}

const onviewOdlazak=(migracijaid,migracijatipsifra)=>{
  setState({...state,newOdlazak:"",viewOdlazakMigracijaId:migracijaid,viewMigracijaTipSifra:migracijatipsifra,viewDolazakMigracijaId:0});
}
const onViewDolazak=(migracijaid)=>{
  setState({...state,newOdlazak:"",editOdlazakMigracijaId:0,editMigracijaTipSifra:"",viewOdlazakMigracijaId:0,viewMigracijaTipSifra:"",viewDolazakMigracijaId:migracijaid});
}

const getDolazakView=()=>{
  if (state.viewDolazakMigracijaId>0) {
    
    return (
      <Drawer placement='right' size={'xl'} isOpen={true}>
      <DrawerOverlay/>
      <DrawerContent roundedTopLeft={'md'}>
          <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
              Dolazak - interna migracija
          </DrawerHeader>
          <DrawerBody>
          <Dolazak onClose={closeOdlazakControl} dolazak_tip_sifra='DKUP' readonly={true} dolazakMigracijaId={state.viewDolazakMigracijaId} newDolazak={false}/>
          </DrawerBody>
      </DrawerContent>
      </Drawer>
  )
  }
}

const onCloseFilter=()=>{

  setFilter({...filter,showFilter:false});
}

const onSetFilterOdlazaka=(f)=>{
  setFilter({...filter,filterData:f,filterStatus:"on",showFilter:false});
}

const getFilterControl=()=>{
  if (filter.showFilter) {
    return (
      <Drawer placement='right' size={'lg'} isOpen={true}>
      <DrawerOverlay/>
      <DrawerContent roundedTopLeft={'md'}>
          <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
              Filtriranje odlazaka
          </DrawerHeader>
          <DrawerBody p='0.5rem'>
                  <OdlasciFilter onSetFilter={onSetFilterOdlazaka} onClose={onCloseFilter} />
          </DrawerBody>
      </DrawerContent>
      </Drawer>
  )
  }
}

const FilterData=(filter)=>{
  const _val=filter.target.value.toLowerCase();
  let _o=odlasci.filter((odl)=>{
      return (odl.knjiga.toLowerCase().includes(_val) || odl.migracija_tip.toLowerCase().includes(_val) || odl.odlposjednik.toLowerCase().includes(_val) || odl.dokument_broj.toLowerCase().includes(_val) || odl.dolposjednik.toLowerCase().includes(_val) || odl.dolknjiga.toLowerCase().includes(_val));
  });
  setPrikaz({...prikaz,odlasciprikaz:_o,currpage:1}); 
}
//
const onshowFilter=()=>{
  setFilter({...filter,showFilter:true});
}
//
const setFilterState=(filtstatus)=>{
  if (filtstatus==="off") {
    setFilter({...filter,filterStatus:filtstatus,filterData:{}});  
  }
  else {
    setFilter({...filter,filterStatus:filtstatus});  
  }
  
}
const displayFilters=()=>{
  if (showFilters) {
    const _dat={datod:'1900-01-01',datdo:'1900-01-01'}
    if (filter.filterData.datumod!==undefined && filter.filterData.datumdo!==undefined) {
      _dat.datod=filter.filterData.datumod;
      _dat.datdo=filter.filterData.datumdo;
    }
    return (
      <Modal isOpen={true} closeOnOverlayClick={false} size={'md'} colorScheme="blue" onClose={()=>{setShowFilters(false)}}>
        <ModalContent shadow={'dark-lg'}>
          <ModalHeader bgColor={'gray.100'} color={'grunt2.600'} fontSize={'sm'}>
            Aktivni filteri
          </ModalHeader>
          <ModalCloseButton size={'sm'}/>
          <ModalBody>
              <OdlazakFilterInfo _knjige={filter.filterData.knjige} _tipoviodlazaka={filter.filterData.odlazaktipovi} _posjednici={filter.filterData.noviposjednici} _klaonice={filter.filterData.klaonice} _drzave={filter.filterData.drzave} _internmigracijeknjige={filter.filterData.noveknjige} _period={_dat} />
            
          </ModalBody>

          <ModalFooter>
            
            
          </ModalFooter>
        </ModalContent>
      </Modal>
      )  
  }
}
const getExcel=()=>{
  setFilter({...filter,ispisType:'xlsx'});
  setDataIsFetching(true);
  setState({...state,toggleShowData:!state.toggleShowData});
}
//
  return (
    <Box display={'flex'} flexDir={'column'} h={'100%'} key='odlasci_component' pl='0.5rem' pr={'0.5rem'} borderWidth={'1px'} borderColor={'silver'} borderBottomRightRadius={'md'}>
        <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Odlasci}/>
        <Box  display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                  <Box mr={'0.5rem'}>
                    <InputGroup size={size} w='20rem'>
                        <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                        <Input focusBorderColor='grunt2.400' placeholder='Filter' maxLength={'20'} onChange={FilterData} />
                    </InputGroup>
                    </Box>
                    <IconButton onClick={onshowFilter} key={'btnFilterOn'} variant={filter.filterStatus!=='off'?'solid':'outline'} colorScheme={'grunt2'} aria-label='Napredno filtriranje' icon={<MdFilterAlt/>} size={size}/>
                    <Tooltip label={'Aktivni filteri'}>
                      <IconButton ml={'0.5rem'} onClick={()=>{setShowFilters(true)}} key={'btnFilterOff'} variant={'outline'} colorScheme={'grunt2'} aria-label='Napredno filtriranje' icon={<MdInfo/>} size={size}/>
                    </Tooltip>
                    <Tooltip label={'Ukloni filtere'}>
                      <IconButton ml={'0.5rem'} onClick={(e)=>setFilterState("off",e)} key={'btnFilterOff'} variant={'outline'} colorScheme={'grunt2'} isDisabled={filter.filterStatus==='off'} aria-label='Napredno filtriranje' icon={<MdFilterAltOff/>} size={size}/>
                    </Tooltip>
                    <Tooltip label={'Izvezi u Excel'}>
                      <IconButton isLoading={filter.ispisType==="xlsx" && dataIsFetching} ml={'0.5rem'} onClick={getExcel} key={'btnExcel'} variant={'outline'} colorScheme={'grunt2'}  aria-label='Ispis' icon={<RiFileExcel2Fill/>} size={size}/>
                    </Tooltip>
                    <Spacer/>
                    <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}>
                    {btnNew()}    
                    </Stack>
        </Box>
        {getOdlasciTable()}
        {getOdlazakControl()}
        {getDolazakView()}
        {getFilterControl()}
        {displayFilters()}
    </Box>
  )
}
